"use strict";

define('uikit/views/form.wrapper',['require','exports','module','underscore','../collections/form','../collections/container','../channel','../elements/button','../elements/text','langs'],function (require, exports, module) {
  var _ = require('underscore');
  var FormView = require('../collections/form');
  var ContainerView = require('../collections/container');
  var channel = require('../channel');
  var ButtonView = require('../elements/button');
  var TextView = require('../elements/text');
  var langs = require('langs');
  var ConfirmButtonOptions = {
    color: 'blue',
    icon: 'check',
    attributes: {
      role: 'button',
      'aria-label': langs.phrase('FormWrapper.Buttons.Confirm')
    }
  };
  var CloseButtonOptions = {
    icon: 'remove',
    attributes: {
      role: 'button',
      'aria-label': langs.phrase('FormWrapper.Buttons.Close')
    }
  };
  var PlaceholderText = TextView.extend({
    tagName: 'div',
    template: function template(props) {
      return props.text + '<i class="icon ' + props.icon + '"></i>';
    },
    options: _.extend({}, TextView.prototype.options, {
      visible: false,
      icon: 'pencil'
    }),
    triggers: {
      'click': 'press'
    },
    events: {
      'keydown': function keydown(ev) {
        if (ev.keyCode == 13) {
          this.triggerMethod('press');
        }
      }
    },
    onRender: function onRender() {
      var txt = this.getOption('text') ? this.getOption('text') : ' not selected';
      if (this.getOption('parent').getOption('editable')) {
        this.$el.attr('tabindex', 0);
        this.$el.attr('role', 'button');
        this.$el.attr('aria-label', 'Value is currently ' + this.getOption('text') + ', press enter to edit');
      } else {
        this.$el.removeAttr('tabindex');
        this.$el.removeAttr('role');
        this.$el.removeAttr('aria-label');
      }
    }
  });
  var FormWrapper = FormView.Field.extend({
    options: _.extend({}, FormView.Field.prototype.options, {
      active: false,
      valueBinding: 'value',
      textBinding: null,
      saveOnBlur: false,
      closeOnBlur: true,
      textOnBlur: true,
      buttonGroup: null,
      confirmButton: null,
      closeButton: null,
      textView: null,
      editable: true,
      editing: false,
      input: null,
      fluid: false,
      model: null,
      disableButton: false
    }),
    update: {
      active: false,
      saveOnBlur: false,
      closeOnBlur: false,
      fluid: false,
      editing: false
    },
    initialize: function initialize() {
      FormView.Field.prototype.initialize.apply(this, arguments);
      this.setupChildrenViews();
      this._updateEditingProperties();
    },
    onFirstRender: function onFirstRender() {
      this.listenTo(this.input, 'change:value', function () {});
      this.on('change:editing change:disabled change:editable', _.debounce(function () {
        this._updateEditingProperties();
      })).on('change:input', function (self, newInput, oldInput) {
        if (oldInput) {
          this.stopListening(oldInput);
        }
        this._updateInputSetup();
        this._updateEditingrPoperties();
      });
      this._updateEditingProperties();
      this._updateInputSetup();
    },
    _updateEditingProperties: function _updateEditingProperties() {
      var editable = this.editable && !this.disabled;
      this.$el.toggleClass('editing', this.editing);
      this.buttonGroup.visible = this.editing && editable;
      this.textView.visible = this.textOnBlur && !this.editing;
      if (this.input) {
        this.input.visible = !this.textOnBlur || this.editing;
        this.input.disabled = !this.editable || this.disabled;
        if (this.editing) {
          if (this.input.isRendered) {
            this.input.focus();
          }
        }
      }
      if (this.editing) {
        this.triggerMethod('begin:edit');
      } else {
        this.triggerMethod('end:edit');
      }
    },
    onChangeModel: function onChangeModel(self, model, oldModel) {
      if (oldModel) {
        this.stopListening(oldModel);
      }
      this.textView.model = this.model;
      this._updateModelListeners();
    },
    _updateModelListeners: function _updateModelListeners() {
      if (this.model) {
        this.stopListening(this.model);
      }
      if (this.model) {
        if (this.input) {
          this.listenTo(this.model, 'change:' + this.valueBinding, function () {
            this.input.value = this.model.get(this.valueBinding);
          });
          this.input.value = this.model.get(this.valueBinding);
        }
        this.listenTo(this.model, 'sync', function () {
          this._ignoreBlur = false;
          this._oldValue = null;
          if (this.closeOnBlur) {
            this.editing = false;
          }
        });
      }
    },
    _updateInputSetup: function _updateInputSetup() {
      this.removeChildrenListeners();
      if (this.input) {
        this.add(this.input, {
          at: 0
        });
        this.setupListeners();
      }
      this._updateModelListeners();
    },
    setupChildrenViews: function setupChildrenViews() {
      this.confirmButton = new ButtonView(_.extend({
        disabled: this.disableButton
      }, ConfirmButtonOptions));
      this.closeButton = new ButtonView(_.extend({}, CloseButtonOptions));
      if (this.disableButton) {
        this.confirmButton.$el.addClass('create-study-disabled');
      }
      this.textView = new PlaceholderText();
      this.textView.model = this.model;
      this.textView.bindings.text = this.textBinding || this.valueBinding;
      this.buttonGroup = new ContainerView({
        className: 'ui buttons'
      }).add(this.confirmButton).add(this.closeButton);
      this.add(this.buttonGroup).add(this.textView);
    },
    onChangeValueBinding: function onChangeValueBinding() {
      this.textView.bindings.text = this.textBinding || this.valueBinding;
      if (this.input) {
        this.input.bindings.value = this.valueBinding;
      }
    },
    onChangeTextBinding: function onChangeTextBinding() {
      this.textView.bindings.value = this.textBinding || this.valueBinding;
    },
    removeChildrenListeners: function removeChildrenListeners() {
      this.stopListening(this.confirmButton);
      this.stopListening(this.closeButton);
      this.stopListening(this.textView);
    },
    setupListeners: function setupListeners() {
      this.listenTo(this.input, 'enter', function () {
        if (!this.input.multiLine) {
          this._ignoreBlur = true;
          this.setInputValue();
        }
      }).listenTo(this.input, 'escape', function () {
        this.resetInputValue();
      }).listenTo(this.input, 'change', function () {
        var validValue = this.input.value && this.input.value.length > 2 && this.input.value.length <= 600;
        if (this.disableButton && validValue && this.confirmButton.disabled) {
          this.confirmButton.disabled = false;
        }
        if (this.disableButton && !validValue && !this.confirmButton.disabled) {
          this.confirmButton.disabled = true;
        }
      });
      this.listenTo(this.input, 'blur', function () {
        if (!this._ignoreBlur) {
          if (this.saveOnBlur) {
            this.setModelValue();
          } else if (this.closeOnBlur) {
            this.resetInputValue();
          }
        }
      });
      this.listenTo(this.confirmButton, 'before:press', function () {
        this._ignoreBlur = true;
        this.setInputValue();
      });
      this.listenTo(this.confirmButton, 'press', function () {
        this._ignoreBlur = false;
      });
      this.listenTo(this.closeButton, 'before:press', function () {
        this.resetInputValue();
      });
      this.listenTo(this.textView, 'press', function () {
        if (this.editable && !this.disabled) {
          this.triggerMethod('before:begin:edit');
          this.editing = true;
        }
      });
    },
    setModelValue: function setModelValue() {
      this._oldValue = null;
      this.model.set(this.valueBinding, this.input.value);
    },
    setInputValue: function setInputValue() {
      if (!this._oldValue) {
        this._oldValue = this.model.get(this.valueBinding);
      }
      this.model.set(this.valueBinding, this.input.value);
      this.triggerMethod('confirm');
    },
    resetInputValue: function resetInputValue() {
      this.editing = false;
      if (this._oldValue) {
        this.model.set(this.valueBinding, this._oldValue);
      } else {
        this.input.value = this.model.get(this.valueBinding);
      }
      this._oldValue = null;
      this.triggerMethod('close');
    },
    updateAttributes: function updateAttributes() {
      FormView.Field.prototype.updateAttributes.apply(this, arguments);
      this.addClass('active', this.getBoolOption('active')).addClass('editable', this.getBoolOption('editable') && !this.getBoolOption('disabled')).addClass('fluid', this.getBoolOption('fluid'));
    }
  });
  channel.reply('form-wrapper', function () {
    return FormWrapper;
  });
  module.exports = FormWrapper;
});

